module.exports = __webpack_public_path__ + "static/media/sidewalk-pdx.a398b7fc.mov";